import { initApi } from "@/utils/api";
import { networkSignal } from "@/utils/signals";
import { Project } from "@/api";

const projectResetSignal = networkSignal<Project>();
export function useProjectReset() {
  async function mutate(projectId: string) {
    const api = initApi();

    return await projectResetSignal.run(async () => api.resetProject({ id: projectId }));
  }

  return { mutate, ...projectResetSignal };
}
